export default __webpack_public_path__ + "static/media/google_play.74acbd38.png";